// extracted by mini-css-extract-plugin
export default {"root":"ThemeToggler_root__3UXYl","circle":"ThemeToggler_circle__0rBvU","icon":"ThemeToggler_icon__PEse-","dark":"ThemeToggler_dark__JPkFY","light":"ThemeToggler_light__x54qi"};